import React from "react";
import { useDispatch, useSelector } from "react-redux";
import cn from "classnames";
// import _ from "underscore";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import Geocode from "react-geocode";
// import { createWorker } from "tesseract.js";

import { Uploader } from "services/action";
import { logo64 } from "utilities/common";

var moment = require("moment");
var MobileDetect = require("mobile-detect");
var md = new MobileDetect(window.navigator.userAgent);

const ImagePreview = ({ dataUri }) => {
  const StateForm = useSelector((state) => state?.Form);

  return (
    <div className={cn("demo-image-preview")} id="lower-left">
      <img src={dataUri} alt="" />

      <div className="camera-button-action">
        {StateForm?.errors?.id ? (
          <div
            className="text-center"
            style={{ marginBottom: 5, marginTop: 10 }}
          >
            <span style={{ color: "red" }}>{StateForm?.errors?.id}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const CameraScreen = ({
  files,
  code,
  setImg,
  onClose,
  numberImg,
  type,
  // setOption,
}) => {
  const Dispatch = useDispatch();

  const [address, setAddress] = React.useState(null);
  const [pos, setPos] = React.useState(null);
  const [image, setImage] = React.useState("");

  function dataURItoBlob(dataURI) {
    let byteString = atob(dataURI.split(",")[1]);

    // separate out the mime component
    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    let blob = new Blob([ab], { type: mimeString });
    return blob;
  }

  function padWithZeroNumber(number, width) {
    number = number + "";
    return number.length >= width
      ? number
      : new Array(width - number.length + 1).join("0") + number;
  }

  function getFileExtention(blobType) {
    // by default the extention is .png
    let extention = IMAGE_TYPES.PNG;

    if (blobType === "image/jpeg") {
      extention = IMAGE_TYPES.JPG;
    }
    return extention;
  }

  function getFileName(imageNumber, blobType) {
    const prefix = `${type}-${code}`;
    const photoNumber = padWithZeroNumber(imageNumber, 4);
    const extention = getFileExtention(blobType);

    return `${prefix}-${photoNumber}.${extention}`;
  }

  function downloadImageFileFomBlob(blob, imageNumber) {
    window.URL = window.webkitURL || window.URL;

    let anchor = document.createElement("a");
    anchor.download = getFileName(imageNumber, blob.type);
    anchor.href = window.URL.createObjectURL(blob);
    let mouseEvent = document.createEvent("MouseEvents");
    mouseEvent.initMouseEvent(
      "click",
      true,
      true,
      window,
      1,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
    anchor.dispatchEvent(mouseEvent);
  }

  function downloadImageFile(dataUri, imageNumber) {
    let blob = dataURItoBlob(dataUri);
    downloadImageFileFomBlob(blob, imageNumber);
  }

  const createWatermarkedDataUri = async (baseImgSrc) => {
    return new Promise(async (resolve) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const baseImg = new Image();
      baseImg.crossOrigin = "anonymous";
      baseImg.src = baseImgSrc;
      baseImg.onload = async () => {
        canvas.width = baseImg.width;
        canvas.height = baseImg.height;
        ctx.drawImage(baseImg, 0, 0);

        // Text watermark at bottom right
        const lines = [
          moment().format("llll"),
          `${pos?.lat}, ${pos?.lng}`,
          address,
        ];
        ctx.font = "12px Arial";
        ctx.fillStyle = "#fff";
        ctx.textAlign = "right";
        ctx.textBaseline = "bottom";
        ctx.shadowColor = "rgba(0,0,0,0.5)";
        ctx.shadowBlur = 2;
        ctx.shadowOffsetX = 1;
        ctx.shadowOffsetY = 1;
        const margin = 8;
        const lineHeight = 14;
        lines.forEach((line, i) => {
          ctx.fillText(
            line,
            canvas.width - margin,
            canvas.height - margin - (lines.length - 1 - i) * lineHeight
          );
        });

        // Logo watermark lower left
        const logoImg = new Image();
        logoImg.crossOrigin = "anonymous";
        logoImg.src = logo64();
        logoImg.onload = () => {
          const logoWidth = 40;
          const logoHeight = (logoImg.height / logoImg.width) * logoWidth;
          ctx.drawImage(
            logoImg,
            margin,
            canvas.height - logoHeight - margin,
            logoWidth,
            logoHeight
          );
          resolve(canvas.toDataURL("image/jpeg", 0.9));
        };
        logoImg.onerror = () => {
          resolve(canvas.toDataURL("image/jpeg", 0.9));
        };
      };
      baseImg.onerror = () => {
        resolve(baseImgSrc);
      };
    });
  };

  const handleCapture = async (u) => {
    const watermarkedDataUri = await createWatermarkedDataUri(u);
    setImage(watermarkedDataUri);
    $handleSave(watermarkedDataUri);
    let os = md.is("iPhone");
    if (os === false) {
      downloadImageFile(watermarkedDataUri, numberImg);
    }
    onClose();
  };

  const $handleSave = async (a) => {
    let payload = {
      file: a,
    };
    const req = await Dispatch(Uploader.$upload(payload));

    if (req?.message === "success") {
      if (files === null) {
        setImg([req?.data])
      } else {
        setImg([...files, req?.data])
      }
    }
  };

  React.useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setPos({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        Geocode.fromLatLng(
          position.coords.latitude,
          position.coords.longitude
        ).then(
          (response) => {
            const address = response.results[0].formatted_address;
            setAddress(address);
          },
          (error) => {
            console.error(error);
          }
        );
      },
      (error) => {
        // See error code charts below.
        console.log(error.code, error.message);
      },
      { enableHighAccuracy: true, timeout: 60000, maximumAge: Infinity }
    );
  }, []);
  return (
    <div>
      <Camera
        onTakePhoto={handleCapture}
        idealFacingMode={FACING_MODES.ENVIRONMENT}
        imageType={IMAGE_TYPES.JPG}
        imageCompression={1}
        isMaxResolution={false}
        isImageMirror={false}
      />

      <div className="d-none">
        <ImagePreview dataUri={image} />
      </div>
    </div>
  );
};

export default CameraScreen;
